<div class="json-tree-viewer">
  <div class="buttons-container">
    <gen-button class="button-expand-collapse"
                (click)="expandAll()"
                [type]="'secondary'"
                [text]="buttonTitle|translate"
                [disabled] = "!!searchText && searchText.length>0"
    ></gen-button>
  </div>
  <div class="below-search-container"></div>
  <div style="padding: 0.2rem 0 0 1.25rem;" >
    <dls-searchbox (search)="searchText = $event;onSearchChange($event);" class="p-tree-search-field">
      <input dlsInput [ngModel]="searchText" placeholder="{{placeholderText | translate}}"
             (ngModelChange)="searchText=$event;onSearchChange($event);">
    </dls-searchbox>
  </div>

  <div class="p-tree p-component tree-container" [ngStyle]="{'min-height': getMaxHeight()}">
    <p-tree #expandingTree
            [value]="treeNodes"
            selectionMode="{{selectionMode}}"
            [(selection)]="selectedNode"
            [loading]="loading"
            (onNodeExpand)="nodeExpand($event)"
            (onNodeCollapse)="nodeCollapse($event)"
            (onNodeSelect)="nodeSelect($event)"
            (onNodeUnselect)="nodeUnselect($event)"
            (onNodeContextMenuSelect)="onNodeRightButtonClick($event)"
            [contextMenu]="contextMenuItems != undefined ? cm: undefined"
            (onFilter) = "onFilter($event)"
            scrollHeight="{{getMaxHeight()}}"
    >
    </p-tree>
    <p-contextMenu #cm [model]="contextMenuItems"></p-contextMenu>
  </div>
</div>
